//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            links: []
        };
    },

    mounted () {
        this.loadLinks();
    },

    methods: {
        loadLinks () {
            this.loading = true;

            axios.get('links/published', {
                limit: 0
            }).then(response => {
                this.links = response.data.data;
                this.pagination = this.$helper.getPaginationData(response);
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        }
    }
};
